<template>
  <div class="searchPage">
    <div class="tit">输入订单号查询：</div>
    <div class="textArea">
      <van-field type="textarea" v-model="keyword" placeholder="输入订单号" />
    </div>
    <div class="custom_btn" @click="handleQuery">
      确认 <i class="iconfont icon-yuyinjiantou"></i>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "searchOrder",
  data() {
    return {
      keyword: "",
    };
  },
  computed: {
    ...mapState(["OPENID", "USERINFO", "userAgent"]),
  },
  created() {},
  methods: {
    handleQuery() {
      let { keyword } = this;
      if (keyword == "") {
        this.$toast("请输入订单号");
        return;
      }
      let orderNo = keyword;
      this.$router.push(`/tekeOrder/tOrderIndex/${orderNo}`);
    },
  },
};
</script>
<style lang="less" scoped>
.searchPage {
  padding: 100px 75px 0;
  box-sizing: border-box;
  .tit {
    font-size: 28px;
    color: #000000;
  }
  .textArea {
    width: 600px;
    height: 300px;
    border: 1px solid #a0a0a0;
    background: #fff;
    margin: 80px 0 40px;
    /deep/ .van-cell {
      height: 100%;
    }
    /deep/ .van-field__body {
      height: 100%;
      .van-field__control {
        height: 100%;
      }
    }
  }
  .custom_btn {
    width: 300px;
    height: 70px;
    background: #373737;
    position: relative;
    font-size: 24px;
    color: #ffffff;
    .iconfont {
      position: absolute;
      transform: rotate(-90deg);
      font-size: 30px;
      right: 20px;
    }
  }
}
</style>
